// extracted by mini-css-extract-plugin
module.exports = {"features":"FeatureList_features__3eNYs","feature":"FeatureList_feature__2T8_m"};